export const appointStatusDsc = {
    payment: 'Payment Status: Set to "paid" to represent a payment that is completed',
    appointment: {
        FollowUp: 'Set to "Follow-up" to represent get re-appointment with the doctor',
        pending: 'Set to "pending" to represent a appointment that is yet to be schedule.possible next step is appointment scheduled',
        scheduled: 'Changed to "Scheduled" to indicate an appointment that is scheduled',
        Completed: "If the appointment has been successfully concluded.",
        Canceled: "If the appointment is canceled by either the patient or the healthcare provider.",
        'Follow-up Scheduled': 'If a follow-up appointment is scheduled.',
        cancel: 'If the appointment cannot be completed for some reason.',
        archived: 'If the appointment is closed and moved to historical records.',
        InProgress: 'Lorem ipsum dollar sumit',
        confirmed : 'When the patient and doctor confirms the appointment.',
    },
    followUpDate: 'Represent a different follow-up date.',
    prescriptionStatus: {
        issued: "Set to 'issued' to represent that a prescription has been issued.",
        notIssued: "Set to 'not_issued' to represent that a prescription has not been issued yet."
    }
}